import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import StoreStoryItme from '../../components/store/StoreStoryItem';

class StoreList extends PureComponent {
  state = {
    gotoPage: 1,
    pageSize: 8,
    pageCount: 1,
    con: 0,
  };
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  _getData = async (gotoPage) => {
    const result = await this._getDataApi(gotoPage);
    //console.log(result)
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const intReturn = result.data[0].intReturn;
    const storeList = result.data[0].listData;
    //console.log(storeList)
    if (intReturn === 0) {
      if (con > 0) {
        if (this._isLoad) {
          this.setState({
            storeList:
              gotoPage === 1
                ? storeList
                : this.state.storeList.concat(storeList),
            con,
            pageCount,
            gotoPage,
          });
        }
      } else {
      }
    }
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId } = this.props;
    const { store } = this.props.childProps;
    const { pageSize } = this.state;
    //console.log(store)
    return axios
      .post(apiUrl + '/storeStoryList', {
        params: {
          board_id: 301,
          gotoPage: gotoPage,
          shop: store,
          pageSize: pageSize,
          loginId: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _more = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 <= pageCount) {
      this._getData(gotoPage + 1);
    } else {
      toast.warn('페이지의 마지막입니다.');
    }
  };
  _renderItem = () => {
    const { storeList } = this.state;

    const list = storeList.map((item, index) => {
      return (
        <StoreStoryItme
          key={index}
          idx={item.idx}
          id={item.id}
          storeName={item.storeName}
          categoryName={item.categoryName}
          title={item.title}
          readnum={item.readnum}
          chuchon={item.chuchon}
          comment_num={item.comment_num}
          writeday={item.writeday}
          filename={item.filename}
          content={item.content}
          active={item.active}
        />
      );
    });
    return list;
  };
  render() {
    const { storeList, con, pageCount, gotoPage } = this.state;
    const { store } = this.props.childProps;
    let storeName;
    if (store === 'hapjung') {
      storeName = '합정점';
    } else if (store === 'daejeon') {
      storeName = '대전점';
    } else if (store === 'gwangju') {
      storeName = '광주점';
    } else if (store === 'busan') {
      storeName = '부산점';
    }
    return (
      <Fragment>
        <div className="store_newsStory">
          {/* 타이틀 */}
          <div className="store_con_tit">
            <h2>[{storeName}] 매장이야기</h2>
            <div className="sub">총 {con}개</div>
          </div>
          {/* 카드 리스트 */}
          <ul className="store_card_list">
            <li className="store_card_item sm_item only">
              {/* only 추가 220118 */}
              <div className="inner_item">
                {/* 카드 내용 서울 seoul, 대전 daejeon, 광주 gwangju, 부산 busan */}
                {storeList ? this._renderItem() : null}
              </div>
              <button className="btn_loadMore" onClick={this._more}>
                LOAD MORE
                <span className="num">
                  ( <b>{gotoPage}</b> / {pageCount} )
                </span>
              </button>
            </li>
          </ul>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(StoreList)));
